import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "../i18n/i18n";
import { captureAuthTokenFromUrl } from "./utils/authToken.js";
import { normalizeSpaPathBeforeBoot } from "./utils/spaPath.js";

captureAuthTokenFromUrl();
normalizeSpaPathBeforeBoot();

document.title = "山海智训";

const root = createRoot(document.getElementById("root"));
root.render(<App />);